import React from 'react';

export default () => (
    <div style={{ textAlign: 'center', maxWidth: '90%' }}>
        <p style={{ fontSize: '40px', fontFamily: "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif" }}>&#9785;</p>
        <p>The application has encountered an error. A notification has been sent to our team of expert developers and we'll look into it. In the meantime you may want to try using a different feature of the app or reloading and trying again.</p>
    </div>
);